export const getDateinMM_DD_YYYY = (date: number | string | Date) => {
    date = new Date(date);

    let day: string | number = date.getDate();
    let month: string | number = date.getMonth() + 1;
    let year = date.getFullYear();

    if (day < 10) {
        day = `0${day}`;
    }

    if (month < 10) {
        month = `0${month}`;
    }

    return {
        date: `${month}-${day}-${year}`,
    }
}